import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Styles from './Main.module.scss';
import { faWifi } from '@fortawesome/free-solid-svg-icons';

import { Navbar, Sidebar, Footer } from 'components/Layout';
import { Loading, Warning } from 'components/Template';
import Routes from 'routes';

export default function Main() {
  const { Main } = Styles;
  const [sidebar, toggleSidebar] = useState(false);
  const loading = useSelector((state) =>
    Object.entries(state).some(
      (reduxSection) =>
        reduxSection[1].loading &&
        (reduxSection[0] !== 'pems' || sidebar) &&
        (reduxSection[0] !== 'cidades' || sidebar),
    ),
  );
  const loadingSync = useSelector((state) => state.queue.loading);

  const online = useSelector((state) => state.queue.online);
  const etecStatus = true;

  return (
    <main>
      <Warning
        message={
          <>
            <p>Aguardando conexão</p>
            <p>
              Para utilizar o sistema em modo offline você deve estar associado
              ao grupo &rsquo;ETEC&lsquo;
            </p>
          </>
        }
        open={!online && !etecStatus}
        abort={false}
        icon={faWifi}
      />
      <>
        <div className={Main}>
          <Loading open={loading} loadingSync={loadingSync} />
          <Navbar
            sidebarOpenState={sidebar}
            toggleSidebar={(e) => {
              toggleSidebar(true);
              e.stopPropagation();
            }}
            etecStatus={etecStatus}
          />
          <Sidebar
            toggle={toggleSidebar}
            open={sidebar && (online || etecStatus)}
          />
          <div style={{ width: '100vw', height: '150px' }} />
          <Routes Loading={loading} />
        </div>
        <Footer />
      </>
    </main>
  );
}
